import React from 'react';
import './Banner.css'
//import {Container} from 'react-bootstrap';
import videobg from '../images/video.mp4';
import { Card } from 'react-bootstrap';

function Banner(props) {
    return(
    <div className="video1" style={{margin:"auto"}}>
        <video autoPlay loop muted style={{ 
            position:"absolute",
            width:"100%",
            height:"700px",
            top:"0px",       
            objectFit:"cover",
            zIndex:"-1",
            paddingTop:"1em"
            
            }}>
            
                
                
            <source src={videobg} type="video/mp4"/>
                
               

        </video>
       
       <div classname="heading" style={{marginTop:"4em",justifyContent:"center",display:"flex"
            }}>
                <Card classname="card" style={{
                    backgroundColor: "rgba(0,0,0,0)",
                    borderColor:"rgba(0,0,0,0)",
                    opacity:"1",
                    height: "400px", width: "1000px", borderRadius: "70px", padding: "3rem",marginBottom:"2rem",
                    minWidth:"500px",maxWidth:"100%"

                }}>
               <Card.Body >
                   <Card.Title>
                            <h1 style={{
                                textAlign: "center", color: "white", marginTop: "1rem", fontSize: "1.8rem", display: "block"
                            
                            
                         }}>
                                Өлшеу техникасы мен өндірісті автоматты түрде басқару саласындағы Сіздің сенімді серігіңіз <br></br>
                                <br></br>
                           Ваш надежный партнер в области измерительной техники и автоматического регулирование процессов</h1>
                   </Card.Title>
                       {/* <p style={{ textAlign: "center", justifyContent: "center", alignSelf: "center" }}>
                            <Button style={{
                                backgroundColor: "#50e3c2",
                                color: "#203367", alignItems: "center", borderColor: "#50e3c2", marginTop: "1rem",
                                borderRadius: "10px",fontSize:"1.5rem"
                            }}>Для выбора помощи</Button>
                        </p>*/}
               </Card.Body>
           </Card>
                
               
          
       </div>
            
           
        
    </div>
      
        
    );
}
export default Banner;